import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import DocumentoModale from "../gestioneDocumenti/Aggiungi&Modifica";
import { Add } from "@mui/icons-material";
import { useFormAccordo } from "./ContextAccordo";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const Documenti = () => {
  const { formState, dispatch } = useFormAccordo();
  const [rows, setRows] = useState(formState.documenti);

  const [pageSize, setPageSize] = useState(5);
  const [openModale, setOpenModale] = useState(false);
  const [iduid, setIduid] = useState("");
  console.log(formState);
  /* console.log(documento); */

  const addDocumentoToRows = (documento) => {
    setRows((prevRows) => [...prevRows, documento]);
    dispatch({
      type: "set_documenti",
      id: documento.idUidDocumento, // or params.row.id depending on your reducer
      payload: {
        ...documento,
      },
    });
    return true;
  };

  const modifyDocumento = (documento) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.idUidDocumento === documento.idUidDocumento
          ? { ...row, ...documento }
          : row,
      ),
    );
    dispatch({
      type: "set_documenti",
      id: documento.idUidDocumento, // or params.row.id depending on your reducer
      payload: {
        ...documento,
      },
    });
    return true;
  };

  const handleOpenModale = (iduid) => {
    setIduid(iduid);
    setOpenModale(true);
  };

  const columns = [
    {
      field: "nome",
      headerName: "Nome",
      minWidth: 300,
      flex: 1,
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography
              fontWeight="bold"
              color="#407ad6"
              sx={{
                cursor: "pointer",
                ":hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => handleOpenModale(params.row.idUidDocumento)}
            >
              {params.row.nome}
            </Typography>

            <Typography fontSize={10}>{params.row.descrizione}</Typography>
          </Box>
        </>
      ),
    },
    {
      field: "tipo",
      headerName: "Tipo",
      minWidth: 200,
      flex: 1,
      headerAlign: "start",
      align: "start",
    },
    {
      field: "fonte",
      headerName: "Fonte",
      minWidth: 200,
      flex: 1,
      headerAlign: "start",
      align: "start",
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography fontWeight="bold">{params.row.fonte}</Typography>
            {params.row.idfonte === 3 ? (
              <Typography fontSize={10}>{params.row.idUidFile}</Typography>
            ) : params.row.idfonte === 2 ? (
              <Typography fontSize={10}>{params.row.link}</Typography>
            ) : (
              <></>
            )}
            <Typography fontSize={12}>{params.row.valoreFonte}</Typography>
          </Box>
        </>
      ),
    },
    {
      field: "abilitato",
      headerName: "Abilitato",
      headerAlign: "start",
      align: "center",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <Switch
          id={`abilitato/${params.id}`}
          name={`abilitato/${params.id}`}
          checked={params.row.abilitato === 1}
          onChange={(e) => {
            setRows((rows) =>
              rows.map((row) =>
                row.idUidDocumento === params.row.idUidDocumento
                  ? { ...row, abilitato: e.target.checked ? 1 : 0 }
                  : row,
              ),
            );
            console.log(params.row.idUidDocumento);
            dispatch({
              type: "set_documenti",
              id: params.row.idUidDocumento, // or params.row.id depending on your reducer
              payload: {
                ...params.row,
                abilitato: e.target.checked ? 1 : 0,
              },
            });
          }}
          sx={{
            "&.MuiSwitch-root .MuiSwitch-switchBase": {
              color: "#ccc",
            },
            "&.MuiSwitch-root .Mui-checked": {
              color: "#407ad6",
            },
          }}
        />
      ),
    },
    {
      field: "tipoObbligatorio",
      headerName: "Tipo Obbligatorio",
      headerAlign: "start",
      align: "start",
      minWidth: 250,
      flex: 1,
    },
  ];

  return (
    <>
      {openModale && (
        <DocumentoModale
          open={openModale}
          setOpen={setOpenModale}
          iduid={iduid} // Pass the iduid to the component
          addDocumentoToRows={addDocumentoToRows}
          modifyDocumento={modifyDocumento}
          rows={rows}
        />
      )}
      <Box display="flex" justifyContent="end" gap={4}>
        <Button
          mr={2}
          variant="contained"
          color="primary"
          onClick={() => handleOpenModale("")}
        >
          <Add />
        </Button>
      </Box>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h6" gutterBottom>
            Risultati: {rows.length}
          </Typography>
        </Grid>
      </Grid>

      <Paper sx={{ width: "100%" }} mt={4}>
        <DataGrid
          columns={columns}
          rows={rows}
          getRowId={(row) => row.idUidDocumento}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20]}
          pagination
          autoHeight
          disableSelectionOnClick
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                No rows in DataGrid
              </Stack>
            ),
          }}
        />
      </Paper>
    </>
  );
};

export default Documenti;
